import mainService from "./authService";
const path = "user";

export function isLoggedIn() {
    return mainService
        .get("/isLoggedIn")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function login(data) {
    return mainService
        .post("/login", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function logout() {
    return mainService
        .post("/logout", {})
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function sendResetEmail(data) {
    return mainService
        .post("/api/password/send", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function resetPassword(data) {
    return mainService
        .post("/api/password/reset", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function checkPasswordToken(data) {
    return mainService
        .post("/api/password/tokenCheck", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export function checkToken(data) {
    return mainService
        .post("/api/checkToken", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function verifyEmail(data) {
    return mainService
        .post("/api/email/verify", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function resendResetEmail(data) {
    return mainService
        .post("/api/password/resend", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function resendActivationEmail(data) {
    return mainService
        .post("/api/email/resend", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function register(data) {
    console.log(data);
    return mainService
        .post("/register", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function updateUserWithToken(data,token) {
    return mainService
        .post("/update/user/" + token, data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function updatePassword(data) {
    return mainService
        .post(path + "/api/password/update", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function profileState() {
    return mainService
        .get("/api/writer/profileState")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function profileStatistic() {
    return mainService
        .get("/api/writer/profileStatistic")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function profileChecklist() {
    return mainService
        .get("/api/writer/profileChecklist")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function getCheckoutStepsData(data) {
    return mainService
        .post("/api/getCheckoutStepsData", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export function updateUserData(data) {  
    return mainService
        .post("/update-user", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function getUserData(data) {
    return mainService
        .post("/get-user", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function completeSelectPlanStep(data) {
    return mainService
        .post("/api/writer/completeSelectPlanStep", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/user.jsx